export default __webpack_public_path__ + "static/media/overviewopen.6b698d9d.png";